export const CONF2_QUERY_PARAMS = {
  jwt: "jwt",
  streamName: "streamname"
};
